import BaseView from '../base'
import { ModelInfo } from '../../defines/model/model'
import CommonUtil from '../../utils/common'
import StorageUtil from '../../utils/storage'
import WebApiClient from '../../api/web'
import { Code } from '../../api/base'
import { Category, DefaultAlgorithm } from '../../defines/const'
import MessageBox from '../../utils/message-box'
import AlgorithmUtil from '../../utils/algorithm'

export default {
  name: 'ModelTrainView',
  mixins: [BaseView],
  components: {},
  props: {
    modelId: ''
  },
  data () {
    return {
      modelInfo: ModelInfo,

      transformersPackages: {
        CLF: null,
        REG: null,
        TSA: null,
        UNS: null
      },

      algorithmsCategories: {
        CLF: null,
        REG: null,
        TSA: null,
        UNS: null
      }
    }
  },
  created () {
    this.modelInfo = StorageUtil.loadModelInfo(this)
    if (!CommonUtil.isEmpty(this.modelInfo)) {
      if (this.$route.meta.trainType !== 'update' || this.modelInfo.modelId === this.modelId) {
        return
      }
    }
    this.modelInfo = {
      modelId: null,
      modelName: '',
      categoryId: '',
      ds: {
        dsName: null,
        uploadFiles: []
      },
      yName: null,
      xName: [],
      xType: [],
      xExcept: [],
      figureSummaryId: null,
      figureDetailId: null,
      transformerPackage: null,
      algorithm: {
        algorithmId: null,
        hyperParams: [],
        optimizeParams: true
      },
      updatedAt: null,
      deleteUploadFile: false,
      dataCollections: null
    }

    if (this.$route.meta.trainType === 'update') {
      WebApiClient.getModel(this, this.modelId).then((response) => {
        if (response.data.code === Code.SUCCESS) {
          const modelInfo = response.data.result
          if (CommonUtil.isNotNull(modelInfo.remarks) &&
            CommonUtil.isNotEmpty(modelInfo.remarks.naviType)) {
            modelInfo.algorithm.algorithmId = modelInfo.remarks.naviType
            modelInfo.algorithm.hyperParams = null
          }
          modelInfo.algorithm.optimizeParams = false
          modelInfo.xType = modelInfo.xType || []
          modelInfo.xExcept = modelInfo.xExcept || []
          if (modelInfo.categoryId === 'UNS' && CommonUtil.isNotEmpty(modelInfo.yName)) {
            modelInfo.xExcept.push(modelInfo.yName)
          }
          modelInfo.xName = modelInfo.xName || []
          modelInfo.categoryId = AlgorithmUtil.algorithm2Purpose(
            modelInfo.categoryId, modelInfo.algorithm.algorithmId)

          if (CommonUtil.isEmpty(modelInfo.transformerPackage.packageId)) {
            modelInfo.transformerPackage.packageId = 'normal_v1'
          }
          modelInfo.transformerPackage.transformers.forEach(transformer => transformer.use = true)

          if (CommonUtil.isEmpty(modelInfo.ds.uploadFiles)) {
            modelInfo.ds.uploadFiles = []
          }
          modelInfo.deleteUploadFile = false
          this.modelInfo = modelInfo

          if (this.$route.name === 'model-update-confirm' &&
            CommonUtil.isEmpty(modelInfo.ds.uploadFiles)) {
            this.changeLocation('model-update-input',
              { modelId: modelInfo.modelId }, false, true)
          } else {
            (this.$route.matched.slice(-1)[0].instances.default).initialize()
          }

          if (this.modelInfo.dataCollections) {
            this.modelInfo.ds.uploadFiles.forEach(uploadFile => {
              uploadFile.isJoined = true
            })
          }
          this.$forceUpdate()
        }
      })
    }
  },
  methods: {
    isValid () {
      return (this.$route.matched.slice(-1)[0].instances.default).isValid()
    },
    saveModelInfo () {
      StorageUtil.saveModelInfo(this, this.modelInfo)
    },
    isSelected (name) {
      return (`model-${this.$route.meta.trainType}-${name}` ===
        this.$route.name)
    },
    isDisabled (name) {
      if (['data', 'transform', 'option', 'confirm'].indexOf(name) >= 0) {
        if (CommonUtil.isEmpty(this.modelInfo.yName) &&
          this.modelInfo.categoryId !== 'UNS') {
          return true
        }
        if (['model-train-input', 'model-update-input'].indexOf(
          this.$route.name) >= 0) {
          if (CommonUtil.isEmpty(this.modelInfo.figureSummaryId)) {
            return true
          }
        }
        if (name === 'transform' && this.modelInfo.categoryId === 'UNS') {
          return true
        }
      }
      return false
    },
    getTransformerSummary (transformerId) {
      const transformersSummaries = this.transformersPackages[this.modelInfo.categoryId].transformerSummaries
      for (const transformerSummary of transformersSummaries) {
        if (transformerSummary.transformerId === transformerId) {
          return transformerSummary
        }
      }
      return null
    },
    getTransformers (categoryId) {
      return new Promise((resolve) => {
        categoryId = categoryId || this.modelInfo.categoryId

        if (CommonUtil.isNotEmpty(this.transformersPackages[categoryId])) {
          resolve(this.transformersPackages[categoryId].packages)
        } else {
          WebApiClient.getTransformerPackages(this, categoryId)
            .then((response) => {
              if (response.data.code === Code.SUCCESS) {
                this.transformersPackages[categoryId] = response.data.result
                resolve(this.transformersPackages[categoryId].packages)
              }
            })
        }
      })
    },
    getTransformerHyperParams (transformerId) {
      return new Promise((resolve) => {
        const transformerSummary = this.getTransformerSummary(transformerId)
        if (CommonUtil.isNotNull(transformerSummary.hyperParams)) {
          return resolve(transformerSummary.hyperParams)
        } else {
          return WebApiClient.getTransformerHyperParams(this, transformerId)
            .then((response) => {
              if (response.data.code === Code.SUCCESS) {
                const hyperParams = response.data.result.hyperParams
                for (const index in hyperParams) {
                  if (hyperParams[index].hyperParamId === 'evaluator') {
                    if (this.modelInfo.categoryId === Category.REG) {
                      hyperParams[index].defaultVal = 'CORR'
                    }
                  } else if (hyperParams[index].hyperParamId === 'lower') {
                    if (this.modelInfo.categoryId === Category.REG) {
                      hyperParams[index].defaultVal = 0.3
                    }
                  }
                }
                transformerSummary.hyperParams = hyperParams
                resolve(transformerSummary.hyperParams)
              }
            })
        }
      })
    },
    getTransformerPackage (transformerPackageId) {
      return new Promise((resolve) => {
        const TransformerPackages = this.transformersPackages[this.modelInfo.categoryId]
        resolve(TransformerPackages.packages.find(
          transformerPackage => transformerPackage.packageId ===
              transformerPackageId))
      }
      )
    },
    getDefaultTransformerPackage (categoryId) {
      return new Promise((resolve) => {
        categoryId = categoryId || this.modelInfo.categoryId
        const transformersPackages = this.transformersPackages[categoryId]

        if (CommonUtil.isNotEmpty(transformersPackages)) {
          resolve(transformersPackages.packages.find(
            transformersPackage => transformersPackage.packageId ===
              transformersPackages.default))
        } else {
          this.getTransformers(categoryId).then(() => {
            resolve(transformersPackages.packages.find(
              transformersPackage => transformersPackage.packageId ===
                transformersPackages.default))
          })
        }
      })
    },
    getAlgorithmId (algorithmId) {
      if (CommonUtil.isEmpty(algorithmId)) {
        if (this.modelInfo.categoryId === Category.CLF) {
          algorithmId = DefaultAlgorithm.CLF
        } else if (this.modelInfo.categoryId === Category.REG) {
          algorithmId = DefaultAlgorithm.REG
        } else if (this.modelInfo.categoryId === Category.TSA) {
          algorithmId = DefaultAlgorithm.TSA
        } else {
          algorithmId = DefaultAlgorithm.UNS
        }
      }

      return algorithmId
    },
    getAlgorithmCategoryId (algorithmId) {
      let algorithmSummary = this.getAlgorithmSummary(algorithmId)
      return algorithmSummary ? algorithmSummary.category.categoryId : null
    },
    getAlgorithmSummary (algorithmId) {
      let algorithmsCategories = this.algorithmsCategories
      algorithmId = this.getAlgorithmId(algorithmId)
      for (let key in algorithmsCategories) {
        if (CommonUtil.isEmpty(algorithmsCategories[key])) continue
        for (let algorithmsCategory of algorithmsCategories[key]) {
          for (let algorithm of algorithmsCategory.algorithms) {
            if (algorithm.algorithmId === algorithmId) {
              return algorithm
            }
          }
        }
      }
      return null
    },
    getAlgorithms (categoryId) {
      return new Promise((resolve) => {
        categoryId = categoryId || this.modelInfo.categoryId

        if (!CommonUtil.isEmpty(this.algorithmsCategories[categoryId])) {
          resolve(this.algorithmsCategories[categoryId])
        } else {
          WebApiClient.getAlgorithms(this, categoryId,
            this.modelInfo.algorithm.algorithmId).then(response => {
            if (response.data.code === Code.SUCCESS) {
              this.algorithmsCategories[categoryId] = response.data.result.categories
              for (let algorithmsCategory of this.algorithmsCategories[categoryId]) {
                for (let algorithmSummary of algorithmsCategory.algorithms) {
                  algorithmSummary.category = algorithmsCategory
                }
              }
              resolve(this.algorithmsCategories[categoryId])
            }
          })
        }
      })
    },
    getAlgorithmHyperParams (categoryId, algorithmId) {
      return new Promise((resolve) => {
        algorithmId = this.getAlgorithmId(algorithmId)
        let algorithmSummary = this.getAlgorithmSummary(algorithmId)
        if (CommonUtil.isNotNull(algorithmSummary.hyperParams)) {
          resolve(algorithmSummary.hyperParams)
        } else {
          WebApiClient.getAlgorithmHyperParams(this, algorithmId)
            .then(response => {
              if (response.data.code === Code.SUCCESS) {
                let hyperParams = response.data.result.hyperParams
                for (let index in hyperParams) {
                  if (hyperParams[index].hyperParamId === 'n_units') {
                    let nUnits = hyperParams.splice(Number(index), 1)[0]
                    for (let i = 0; i < 3; i++) {
                      hyperParams.splice(Number(index) + i, 0,
                        Object.assign({}, nUnits, {
                          hyperParamId: `n_units_${i + 1}`
                        }))
                    }
                    break
                  }
                }
                algorithmSummary.hyperParams = hyperParams
                resolve(algorithmSummary.hyperParams)
              }
            })
        }
      })
    },
    onClickTrainNavigationLink (name) {
      if (this.isDisabled(name)) {
        return
      }

      this.changeLocation(`model-${this.$route.meta.trainType}-${name}`, {
        modelId: this.modelId
      })
    },
    prevRoute () {
      const prevRoute = this.getPrevRoute()
      if (prevRoute != null) {
        this.changeLocation(prevRoute, {
          // this.changeLocation(this.$route.meta.prev, {
          modelId: this.modelId
        })
      }
    },
    getPrevRoute () {
      const prev = this.$route.meta.prev
      if (this.modelInfo.categoryId !== 'UNS' ||
        ['model-update-transform', 'model-train-transform'].indexOf(prev) < 0) {
        return prev
      } else {
        return `model-${this.$route.meta.trainType}-data`
      }
    },
    nextRoute () {
      const nextRoute = this.getNextRoute()
      if (nextRoute != null) {
        this.changeLocation(nextRoute, {
          modelId: this.modelId
        })
      }
    },
    getNextRoute () {
      const next = this.$route.meta.next
      if (this.modelInfo.categoryId !== 'UNS' ||
        ['model-update-transform', 'model-train-transform'].indexOf(next) < 0) {
        return next
      } else {
        return `model-${this.$route.meta.trainType}-option`
      }
    },
    onBeforeChangeLocation (name) {
      if (['model-list', 'model-detail'].indexOf(name) < 0) {
        this.saveModelInfo()
      }
    },
    cancelTrain () {
      const confirmMessage = this.$route.meta.trainType === 'train'
        ? 'モデルの作成をキャンセルし、モデル一覧に戻ります。<br>よろしいですか？'
        : 'モデルの更新をキャンセルし、モデル詳細に戻ります。<br>よろしいですか？'
      MessageBox.confirm(this, confirmMessage, {
        dangerouslyUseHTMLString: true
      }).then(() => {
        if (this.$route.meta.trainType === 'train') {
          this.changeLocation('model-list', null, false, true)
        } else {
          this.changeLocation('model-detail', {
            modelId: this.modelInfo.modelId
          }, false, true)
        }
      }).catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/model/train.js